"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _DropdownContext = require("./context/DropdownContext");

var _Dropdown = _interopRequireDefault(require("./Dropdown.theme"));

var _PortalComponent = _interopRequireDefault(require("./PortalComponent"));

var _styles = require("./styles");

var DropdownList = function DropdownList(_ref) {
  var children = _ref.children,
      direction = _ref.direction,
      overflow = _ref.overflow;

  var _useDropdown = (0, _DropdownContext.useDropdown)(),
      dimensionsBox = _useDropdown.dimensionsBox,
      dimensionsButton = _useDropdown.dimensionsButton,
      isOpen = _useDropdown.isOpen,
      changeDropdownState = _useDropdown.changeDropdownState,
      setDimensionsBox = _useDropdown.setDimensionsBox;

  var boxRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (boxRef.current) {
      setDimensionsBox({
        width: boxRef.current.offsetWidth,
        height: boxRef.current.offsetHeight
      });
    }

    var handleClickOutside = function handleClickOutside(event) {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        changeDropdownState(!isOpen);
      }
    };

    if (isOpen) {
      window.addEventListener('mousedown', handleClickOutside);
    }

    return function () {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, setDimensionsBox, changeDropdownState]);
  var node = document.createElement('div');
  node.setAttribute('id', 'dropdown-items');
  (0, _react.useEffect)(function () {
    var checkDropdownItems = document.getElementById('dropdown-items');
    if (!checkDropdownItems) document.body.appendChild(node);
  }, [node]);
  var dropDownTheme = (0, _Dropdown.default)(dimensionsButton, dimensionsBox, overflow);
  var Child = overflow ? /*#__PURE__*/_react.default.createElement(_PortalComponent.default, {
    id: "dropdown-items"
  }, /*#__PURE__*/_react.default.createElement(_styles.DropdownBox, {
    ref: boxRef,
    direction: dropDownTheme[direction]
  }, /*#__PURE__*/_react.default.createElement(_styles.List, null, children))) : /*#__PURE__*/_react.default.createElement(_styles.DropdownBox, {
    ref: boxRef,
    direction: dropDownTheme[direction]
  }, /*#__PURE__*/_react.default.createElement(_styles.List, null, children));
  return isOpen && Child;
};

DropdownList.defaultProps = {
  direction: 'bottom'
};
var _default = DropdownList;
exports.default = _default;